const entity = 'users'
const entitySingle = 'users'
const tableIcon = 'cil-persons'

export {
  entity,
  entitySingle,
  tableIcon
}
